<!--首页-->
<template>
  <div class="gray-back" style="height: 100%">
    <div class="box"  >
      <!--<div class="row1" v-for="(row,i) in catelist"  v-if="i<3">-->
        <!--<img v-rblink="{name:'NewsList',query:{cate_id:row.id}}" :src="row.pic_url" />-->
      <!--</div>-->
      <div class="row3">
        <div class="imgbg">
          <img   :src="catelist[0].pic_url" />
          <div  v-rblink="{name:'ExameApplyListMine',query:{}}"    class="btn" >申报</div>
          <div  v-rblink="{name:'NewsList',query:{cate_id:catelist[0].id}}"  style="top:80px" class="btn">展示</div>
        </div>

        <div class="imgbg">
          <img   :src="catelist[1].pic_url" />
          <div class="btn" v-rblink="{name: 'LevelApplyList'}">申报</div>
          <div  v-rblink="{name: 'LevelApplyList'}"  style="top:80px" class="btn">展示</div>
        </div>

        <div class="imgbg">
          <img   :src="catelist[2].pic_url" />
          <div class="btn" @click="$toast('正在建设中')">申报</div>
          <div  v-rblink="{}"  @click="$toast('正在建设中')" style="top:80px" class="btn">展示</div>
        </div>


        <div class="imgbg">
          <img   :src="catelist[3].pic_url" />
          <div class="btn" v-rblink="{name: 'AbilityApplyList'}" >申报</div>
          <div  v-rblink="{name: 'AbilityApplyList'}"  style="top:80px" class="btn">展示</div>
        </div>


        <!-- <div class="imgbg">
          <img   :src="catelist[4].pic_url" />
          <div class="btn" v-rblink="{name:'ClubDetailSihaoApply'}">申报</div>
          <div  v-rblink="{name:'ClubDetailSihaoApplySuccess'}"  style="top:80px" class="btn">展示</div>
        </div> -->
        <div style="clear: both"></div>
      </div>


      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">


          <div v-for="(row,i) in list" :key="i" v-rblink="{name:'NewsDetail',query:{id:row.id }}" >
            <!-- 无图 style==1 -->
            <NewsItem1 :row="row" v-if="row.pics.length==0"></NewsItem1>
            <!-- 有图 style==2 -->
            <NewsItem2 :row="row" v-if="row.pics.length==1"></NewsItem2>
            <!-- 视频 style==3 -->
            <NewsItem3 v-if="false"></NewsItem3>
            <!-- 多图 style==4 -->
            <NewsItem4 :row="row" v-if="row.pics.length>1"></NewsItem4>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>

    <LoginDialog :show="loginShow" @loginSuccess="loginSuccess" @loginCancel="loginCancel" />
  </div>
</template>
<style scoped>

.box {
  background: #f8f8f8;
  padding-bottom: 50px;
  overflow: hidden;
}
  .row1{
    /*padding: 10px;*/
    margin: 0 10px;
  }
  .row1 img{
    width: 100%;
    margin: 10px 0 0 0 ;
  }
  .row3{
    /*display: flex;*/
    /*align-items: center;*/
    /*justify-content: space-between;*/
    margin: 10px 10px;
    /*flex-wrap: wrap;*/
  }
  .row3 img{
    width: 100%;
    /*float: left;*/
    /*width: calc(33.33% - 10px);*/
    /*margin: 0 10px 10px 0;*/
  }
  .imgbg{
    float: left;
    position: relative;
    width: calc(33.33% - 10px);
    margin: 0 10px 10px 0;
  }
  .imgbg .btn{
    position: absolute;
    top: 50px;
    left: 0;
    right: 0;
    text-align: center;
    width: 70px;
    margin: 0 auto;
    border: 1px solid #fff;
    border-radius: 10px;
    color: #fff;
  }
  .logo-ul{
    background: #fff;
    border-radius: 10px;
    height: 100px;
    margin: 0 10px;
  }
  .logo-ul div{
    text-align: center;
    float: left;
    width: calc(33.33% - 10px);
    margin: 0 0 10px 10px;
    line-height: 110px;
    height: 110px;
  }
  .logo-ul img{
    width: 100%;
    display: inline-block;
  }

</style>

<script>
import Vue from "vue";
import { Tab, Tabs, List, PullRefresh, Toast } from "vant";

import NewsItem2 from "@/components/news/NewsItem2.vue";
import NewsItem3 from "@/components/news/NewsItem3.vue";
import NewsItem1 from "@/components/news/NewsItem1.vue";
import NewsItem4 from "@/components/news/NewsItem4.vue";
import LoginDialog from '@/components/LoginDialog.vue';
Vue.use(Tab)
  .use(Tabs)
  .use(PullRefresh)
  .use(List)
  .use(Toast);

export default {
  name: "NewsList",
  components: {
    NewsItem2,
    NewsItem3,
    NewsItem1,
    NewsItem4,
    LoginDialog
  },

  data: function() {
    return {
      isLoading: false,
      loading: false,
      finished: false,
      active: 0,
      activeTab: [
      ],
      catelist:[],
      list:[],
      params:{
        cate_id:64,
        pageNo:1,
        pageSize:10
      },
    };
  },
  filters: {
  },
  mounted() {
    document.title = "运动员等级";
    this.params.pageNo = 1;
    this.loading = true;
    this.finished = false;
    let that = this;

    that.$api.get(
            "/api/cms/catelist",{
              parent_id:58
            },
            res => {
              that.catelist = res.data
            },
            res => {
              Toast(res.msg);
            }
    );

    this.fetch();
  },
  destroyed() {},
  methods: {
    fetch() {
      let that = this;
      that.$api.get(
              "/api/cms/cmsList",that.params,
              res => {

                that.loading = false;
                console.log('fetchok')
                if (res.data.currentpage == 1) {
                  that.isLoading = false;
                  that.list = res.data.list;
                } else {
                  that.list = that.list.concat(res.data.list);
                }

                if (res.data.list.length == 0) {
                  that.finished = true;
                }
                that.params.pageNo += 1;
              },
              res => {
                Toast(res.msg);
              }
      );
    },
    onRefresh() {
      let that = this;
      that.params.pageNo = 1;
      that.fetch();
    },
    onLoad() {
      // console.log(1)
      // 异步更新数据
      console.log("this.params.pageNo");
      if (this.params.pageNo > 1) {
        setTimeout(() => {
          this.fetch();
        }, 500);
      }
    },
  }
};
</script>



// WEBPACK FOOTER //
// Yundongyuandengji.vue?515e03e6